import { CreateVaultSteps } from 'common/enums';
import { VaultsNew } from 'models/vault-new';

const mandatoryFieldsErrors: NewVaultErrorsType = {
  title: '',
  contributors: [],
};

export type VaultNewStateType = {
  isLoading: boolean;
  step: CreateVaultSteps;
  // The storage plan chosen in step 2 (25GB..1TB, one-time/annual).
  planSelected: StoragePlanType | null;
  vault: VaultNewRequestType;
  // Local object URL for the uploaded cover, kept alongside the signed id so
  // the footer and the review step can show the image before it is saved.
  coverPreviewUrl: string | null;
  errors: NewVaultErrorsType;
};

const VaultNewinitialState: VaultNewStateType = {
  isLoading: false,
  step: CreateVaultSteps.information,
  planSelected: null,
  vault: new VaultsNew(),
  coverPreviewUrl: null,
  errors: mandatoryFieldsErrors,
};

type NewVaultAction =
  | { type: 'IS_LOADING'; isLoading: boolean }
  | { type: 'MOVE_STEP'; direction: 'next' | 'back' }
  | { type: 'GO_TO_STEP'; step: CreateVaultSteps }
  | { type: 'PLAN_SELECTED'; plan: StoragePlanType }
  | { type: 'VAULT_INPUT'; field: string; value: string }
  | {
      type: 'UPLOAD_IMAGE';
      coverSignedId: string | undefined;
      previewUrl: string | null;
    }
  | { type: 'UPDATE_ERRORS'; errors: NewVaultErrorsType }
  | { type: 'UPDATE_CONTRIBUTORS'; contributors: ContributorType[] };

const VaultNewReducer = (state: VaultNewStateType, action: NewVaultAction) => {
  switch (action.type) {
    case 'IS_LOADING':
      return {
        ...state,
        isLoading: action.isLoading,
      };

    case 'MOVE_STEP':
      return {
        ...state,
        step: (action.direction === 'next'
          ? state.step + 1
          : state.step - 1) as CreateVaultSteps,
      };

    case 'GO_TO_STEP':
      return {
        ...state,
        step: action.step,
      };

    case 'UPDATE_CONTRIBUTORS':
      return {
        ...state,
        vault: {
          ...state.vault,
          contributors: action.contributors,
        },
      };

    case 'UPLOAD_IMAGE':
      return {
        ...state,
        coverPreviewUrl: action.previewUrl,
        vault: {
          ...state.vault,
          coverSignedId: action.coverSignedId,
        },
      };

    case 'UPDATE_ERRORS':
      return {
        ...state,
        errors: action.errors,
      };

    case 'VAULT_INPUT':
      return {
        ...state,
        vault: {
          ...state.vault,
          [action.field]: action.value,
        },
      };

    case 'PLAN_SELECTED':
      return {
        ...state,
        planSelected: action.plan,
      };

    default:
      return state;
  }
};

export { VaultNewReducer, VaultNewinitialState };
export type { NewVaultAction };
